import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InfoStoreModule } from '@wonder-core-ng/info-store/info-store.module';
import { AuthHttpInterceptor } from '@wonder-core-ng/session-store/auth-http.interceptor.service';
import { QueryEngineApiService } from '../query-engine/query-engine.api.service';
import { QueryConfigEffects } from './query-config.effects';
import * as fromQueryConfig from './query-config.reducer';
import { QueryConfigService } from './query-config.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromQueryConfig.queryConfigFeatureKey, fromQueryConfig.reducer),
    EffectsModule.forFeature([QueryConfigEffects]),
    InfoStoreModule,
  ],
  providers: [
    QueryEngineApiService,
    QueryConfigService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class QueryConfigStoreModule {}
